// Filter bar — persona/JTBD dropdowns, stats, confidence legend

interface FilterBarProps {
  personas: { id: string; title: string }[]
  jtbds: { id: string; title: string }[]
  personaFilter: string | null
  jtbdFilter: string | null
  onPersonaChange: (id: string | null) => void
  onJtbdChange: (id: string | null) => void
  onClear: () => void
  stats: { totalEntities: number; totalLinks: number; unlinkedProblems: number; unlinkedCapabilities: number } | null
}

const LEGEND = [
  { label: 'Hypothesis', cls: 'bg-warm-400 border-dashed border-warm-500' },
  { label: 'Signal', cls: 'bg-business/15 border-solid border-business' },
  { label: 'Pattern', cls: 'bg-solution/15 border-solid border-solution' },
  { label: 'Validated', cls: 'bg-market/15 border-solid border-market' },
]

export function FilterBar({
  personas, jtbds, personaFilter, jtbdFilter,
  onPersonaChange, onJtbdChange, onClear, stats,
}: FilterBarProps) {
  return (
    <div className="flex items-center gap-3 px-5 py-2.5 bg-warm-100 border-b border-border flex-shrink-0">
      <span className="text-[12px] font-medium text-text-muted uppercase tracking-wide">Focus</span>

      <select
        className="text-[13px] px-2.5 py-1 border border-border rounded-md bg-surface text-text cursor-pointer appearance-none pr-7 bg-no-repeat bg-[right_8px_center]"
        value={personaFilter || ''}
        onChange={e => onPersonaChange(e.target.value || null)}
      >
        <option value="">All personas</option>
        {personas.map(p => (
          <option key={p.id} value={p.id}>{p.title}</option>
        ))}
      </select>

      {personaFilter && jtbds.length > 0 && (
        <select
          className="text-[13px] px-2.5 py-1 border border-border rounded-md bg-surface text-text cursor-pointer appearance-none pr-7"
          value={jtbdFilter || ''}
          onChange={e => onJtbdChange(e.target.value || null)}
        >
          <option value="">All JTBDs</option>
          {jtbds.map(j => (
            <option key={j.id} value={j.id}>{j.title}</option>
          ))}
        </select>
      )}

      {(personaFilter || jtbdFilter) && (
        <button
          onClick={onClear}
          className="text-[12px] text-text-muted hover:text-danger px-2 py-1"
        >
          Clear
        </button>
      )}

      {/* Stats */}
      {stats && (
        <div className="ml-auto flex gap-4 text-[12px] text-text-muted">
          <span><span className="font-semibold text-text-secondary">{stats.totalEntities}</span> entities</span>
          <span><span className="font-semibold text-text-secondary">{stats.totalLinks}</span> links</span>
          {stats.unlinkedProblems > 0 && (
            <span className="text-danger">{stats.unlinkedProblems} unlinked problems</span>
          )}
        </div>
      )}

      {/* Legend */}
      <div className="flex gap-3 ml-4 pl-4 border-l border-border">
        {LEGEND.map(l => (
          <div key={l.label} className="flex items-center gap-1.5 text-[11px] text-text-muted">
            <div className={`w-2 h-2 rounded-full border-[1.5px] ${l.cls}`} />
            {l.label}
          </div>
        ))}
      </div>
    </div>
  )
}
